import { useTranslation } from '@wix/fe-essentials/react';
import { RuleListStatus } from '@wix/rules-panel-ui';
import { assertNotOptional } from '@wix/seo-common-core';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { isApplyTriggeredAtom, verticalsDrillInPageIdAtom } from '../../atoms/session-atoms';
import { showShouldVerifyItemTypeModal } from '../../components/modals/show-should-verify-item-type-modal';
import { SITE_LEVEL_PAGE_ID } from '../../consts';
import { usePanelStateAtom } from '../../hooks/rules-state';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { hasFailedRulesInGroupExcept, isStaticPage } from './helpers';
import { useVerify } from './use-verify';
export const useRuleBase = () => {
  const {
    setRuleState,
    getGroupData
  } = usePanelStateAtom();
  const {
    verify
  } = useVerify({});
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const setIsApplyTriggered = useSetAtom(isApplyTriggeredAtom);
  const setDrillInPageId = useSetAtom(verticalsDrillInPageIdAtom);
  const updateRuleStateAndVerifyIfNeeded = useCallback(async (pageId, ruleId, newState, modifiedGlobalSectionCompIds) => {
    const groupData = getGroupData(pageId);
    assertNotOptional(groupData, 'groupData');
    setRuleState(pageId, ruleId, newState);
    const isVerticalGroup = pageId !== SITE_LEVEL_PAGE_ID && !isStaticPage(groupData.itemType);
    const shouldVerify = newState.status === RuleListStatus.passed && !hasFailedRulesInGroupExcept(groupData, ruleId);
    if (shouldVerify) {
      if (isVerticalGroup) {
        showShouldVerifyItemTypeModal({
          a11yWizardAdapter,
          biLogger,
          editorHost,
          handleScan: async () => {
            verify(groupData, modifiedGlobalSectionCompIds);
            setDrillInPageId(undefined);
          },
          handleSkipScan: () => {},
          itemType: groupData.itemType,
          t
        });
      } else {
        await verify(groupData, modifiedGlobalSectionCompIds);
      }
    }
  }, [a11yWizardAdapter, biLogger, editorHost, getGroupData, setDrillInPageId, setRuleState, t, verify]);
  return {
    setIsApplyTriggered,
    updateRuleStateAndVerifyIfNeeded
  };
};
//# sourceMappingURL=use-rule-base.js.map